import styled from 'styled-components';

export const AttendanceHeaderContainer = styled.div`
  .header-container {
    width: 100%;
    background-color: #ffffff;
  }
  .back-container {
    display: flex;
    align-items: center;
  }
  .backbutton {
    outline: none;
    border: none;
    background-color: transparent;

    img {
      vertical-align: middle;
      margin-right: 0.75rem;
    }
  }

  .header-top {
    padding: 1.5rem 3rem 1.5rem 3rem;
    border-bottom: 1px solid #e0e0e0;
    align-items: center;
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: 500;
      font-size: 1.5rem;
      color: #3d4457;
    }
    @media (max-width: 600px) {
      & {
        padding: 1rem 1.5rem 1rem 1.5rem;
        width: 100%;
      }
    }
  }
  .button {
    &.cancel-button {
      background-color: white;
      margin-left: 1rem;
      border: 0.0625rem solid ${({theme}) => theme.colors.primary};

      :active,
      :focus {
        border-color: ${({theme}) => theme.colors.primary};
      }

      .label {
        color: ${({theme}) => theme.colors.primary};
      }
    }
  }
  .header-bottom {
    padding: 1.5rem 3rem 1.5rem 3rem;
    align-items: center;
    display: flex;
    border-bottom: 1px solid #e9e9e9;
    justify-content: space-between;
    .left-content {
      display: flex;
      flex-direction: column;
    }
    .right-content {
      display: flex;
    }
    .class-name {
      font-size: 16px;
      color: #5ba1f2;
    }
    .session-time,
    .teacher-name {
      font-size: 16px;
      color: #6d7579;
      margin-left: 1rem;
      display: flex;
      align-items: center;
      img {
        vertical-align: unset;
      }
    }

    .title {
      font-weight: 500;
      font-size: 1.25rem;
      color: #0c181f;
      margin-bottom: 0.25rem;
      text-transform: capitalize;
    }
    @media (max-width: 900px) {
      & {
        display: flex;
        flex-direction: column;
        padding: 1rem 1.5rem 1rem 1.5rem;
        width: 100%;
      }
      .right-content {
        margin-top: 1rem;
      }
    }
    @media (max-width: 500px) {
      & {
        padding: 1rem 1.5rem 1rem 1.5rem;
        width: 100%;
      }
      .right-content {
        display: flex;
        flex-direction: column;
        .button {
          &.cancel-button {
            margin-left: unset;
            margin-top: 1rem;
          }
        }
      }
      .left-content {
        .details {
          flex-wrap: wrap;
          .teacher-name {
            margin-left: unset;
          }
        }
      }
    }
  }
`;
